//manage dashboard page loading
export const setLoading = (isLoading) => ({
    type: 'SET_LOADING',
    isLoading
})